import { gql } from '@apollo/client';

export default gql`
  query FreeShippingCountries {
    magento2 {
      storeConfig {
        storeCode
        freeShippingCountries
      }
    }
  }
`;
